<template>
  <div class="field">
    <div class="control">
      <!--div class="select is-multiple">
                <select multiple v-model="currentCollections">
                    <option :value="undefined"></option>
                  <option v-for="collection in collections" :key="collection._id" :value="collection._id">{{collection.title}}</option>
                </select>
              </div-->
      <label
        class="checkbox is-block"
        v-for="collection in collections"
        :key="collection._id"
      >
        <input type="checkbox" :value="collection._id" v-model="currentCollections"/>
        {{ collection.title }}
      </label>
    </div>
  </div>
</template>

<script>
import { languageManager } from '@/mixins/LanguageManager'

export default {
  props: {
    selectedCollections: {
      type: Array,
      default () {
        return []
      }
    }
  },
  model: {
    prop: 'selectedCollections'
  },
  data () {
    return {
      currentCollections: this.selectedCollections
    }
  },
  watch: {
    currentCollections () {
      this.$emit('input', this.currentCollections)
    },
    selectedCollections () {
      this.currentCollections = this.selectedCollections
    }
  },
  mixins: [languageManager],
  mounted () {
    this.$store.dispatch('fetchCollections')
  },
  computed: {
    collections () {
      return this.$store.state.collections.map(collection => {
        return this.transformObject(collection)
      })
    }
  }
}
</script>

<style>
</style>
